import { login } from './login.config';

var configs = {
    //本地开发环境的接口地址(npm run dev)
    /**
     * base 为默认的baseURL, 在不使用{#xxx}类型配置。
     */
    dev: {
        base: '//localhost:8087', //本地开发调试用的服务器地址，修改不会影响发布
        mock: '//127.0.0.1:8087', //本地开发调试用的服务器地址，修改不会影响发布
        npgw: `https://test-${login.accessTestInstance}.fastindexs.com/npgw`, // 通过网站实例获取租户信息 租户级菜单权限服务 http://10.12.68.72:8123/pms/swagger-ui.html#/
        bm: `https://test-${login.accessTestInstance}.fastindexs.com`, // 子账户列表
        host: `https://test-${login.accessTestInstance}.fastindexs.com`, // host
        consoleHost: `https://test-api-console.300.cn`, // 会员中心host
        openHost: `https://test-developer.platopen.com`, // 开放平台host
        appstoreHost: `https://test-api-shop.300.cn`, // 订单相关host
        payPage: `https://test-console.300.cn/expenses/order-list/1/order-detail`,
        scrm: `https://scrm-test.ceboss.cn/api-scrm`,
        multipleApp: `https://test-multiplec.fastoper.com/`,
        weibo: `http://test.cesite.cn/for/`,//微博
        yidaba:'https://huitui.yidaba.com',//一大把 seo优化
        sensors: 'https://cdp-event.ceboss.cn/sa?project=default', // 神策埋点地址
        url300: 'https://test-console.300.cn/index', // 300会员跳转地址
        visitor: 'https://test-web-visitor.yun300.cn', // 励销
        chatTenantId:'311227',//测试环境智慧客服对用租户
        douyinSocket:'https://test-sns.fastindexs.com',//抖音/小红书socket地址
        dingtalk: 'https://oapi.dingtalk.com',//钉钉
        inquiryFormId: '1455599020851777536',//智能筛选询价表单id
        requestFormId: '1455221039012696064',//智能筛选申请样品id
    },
    dev_mock: {
        base: '//localhost:8087', //本地开发调试用的服务器地址，修改不会影响发布
        mock: '//localhost:80', //本地开发调试用的服务器地址，修改不会影响发布
        npgw: `https://test-${login.accessTestInstance}.fastindexs.com/npgw`, // 通过网站实例获取租户信息 租户级菜单权限服务 http://10.12.68.72:8123/pms/swagger-ui.html#/
        bm: `https://test-${login.accessTestInstance}.fastindexs.com`, // 子账户列表
    },
    //待发布的开发环境的接口地址(npm run build-dev)
    dev_build: {
        base: '//xxx.dev61.xxx.com',
        mock: '//127.0.0.1:8087', //本地开发调试用的服务器地址，修改不会影响发布
        node_api: '//xxx-node.dev61.xxx.com',
        bm: '/', // 子账户列表
    },
    //测试环境的接口地址
    test: {
        base: '/',
        mock: '//127.0.0.1:8087', //本地开发调试用的服务器地址，修改不会影响发布
        npgw: '/npgw',
        bm: '/', // 子账户列表
        openHost: `https://test-developer.platopen.com`, // 开放平台host
        consoleHost: `https://test-api-console.300.cn`, // 会员中心host
        appstoreHost: `https://test-api-shop.300.cn`, // 订单相关host
        payPage: `https://test-console.300.cn/expenses/order-list/1/order-detail`,
        scrm: `https://scrm-test.ceboss.cn/api-scrm`,
        multipleApp: `https://test-multiplec.fastoper.com/`,//多端
        weibo: `http://test.cesite.cn/for/`,//微博
        yidaba: 'https://huitui.yidaba.com',//一大把 seo优化
        sensors: 'https://cdp-event.ceboss.cn/sa?project=default', // 神策埋点地址
        url300: 'https://test-console.300.cn/index', // 300会员跳转地址
        visitor: 'https://test-web-visitor.yun300.cn', // 励销
        chatTenantId:'311227',//测试环境智慧客服对用租户
        douyinSocket:'https://test-sns.fastindexs.com',//抖音/小红书socket地址
        dingtalk: 'https://oapi.dingtalk.com',//钉钉
        inquiryFormId: '1455599020851777536',//智能筛选询价表单id
        requestFormId: '1455221039012696064',//智能筛选申请样品id
    },
    //演示环境的接口地址
    demo: {
        base: '/',
        mock: '//127.0.0.1:8087', //本地开发调试用的服务器地址，修改不会影响发布
        npgw: '/npgw',
        bm: '/', // 子账户列表
    },
    //预发布环境的接口地址
    pre: {
        base: '/',
        mock: '//127.0.0.1:8087', //本地开发调试用的服务器地址，修改不会影响发布
        npgw: '/npgw',
        bm: '/', // 子账户列表
        openHost: `https://developer.platopen.com`, // 开放平台host
        consoleHost: `https://pre-api-console.300.cn`, // 会员中心host
        appstoreHost: `https://pre-api-shop.300.cn`, // 订单相关host
        payPage: `https://new-console.300.cn/expenses/order-list/1/order-detail`,
        scrm: `https://scrm-pre.ceboss.cn/api-scrm`,
        yidaba: 'https://huitui.yidaba.com',//一大把 seo优化
        sensors: 'https://cdp-event.ceboss.cn/sa?project=default', // 神策埋点地址
        url300: 'https://new-console.300.cn/index', // 300会员跳转地址
        visitor: 'https://pre-web-visitor.yun300.cn', // 励销
        chatTenantId:'311284',//测试环境智慧客服对用租户
        inquiryFormId: '1455599020851777536',//智能筛选询价表单id
        requestFormId: '1455221039012696064',//智能筛选申请样品id
    },
    prod: {
        //生产环境的接口地址
        base: '/',
        mock: '//127.0.0.1:8087', //本地开发调试用的服务器地址，修改不会影响发布
        npgw: '/npgw',
        bm: '/', // 子账户列表
        openHost: `https://developer.platopen.com`, // 开放平台host
        consoleHost: `https://new-api-console.300.cn`, // 会员中心host
        appstoreHost: `https://api-shop.300.cn`, // 订单相关host
        payPage: `https://new-console.300.cn/expenses/order-list/1/order-detail`,
        scrm: `https://scrm.ceboss.cn/api-scrm`, 
        multipleApp: `https://multiplec.fastoper.com/`,//多端
        weibo: `http://cesite.cn/for/`,//微博
        yidaba: 'https://huitui.yidaba.com',//一大把 seo优化
        sensors: 'https://cdp-event.ceboss.cn/sa?project=production', // 神策埋点地址
        url300: 'https://new-console.300.cn/index', // 300会员跳转地址
        visitor: 'https://web-visitor.yun300.cn', // 励销
        chatTenantId:'261899',//测试环境智慧客服对用租户
        douyinSocket:'https://sns.fastindexs.com',//抖音/小红书socket地址
        inquiryFormId: '1457425649724538880',//智能筛选询价表单id
        requestFormId: '1457423268785545216',//智能筛选申请样品id
    },

    private: {
        //私有化环境
        base: '/',
        mock: '//127.0.0.1:8087', //本地开发调试用的服务器地址，修改不会影响发布
        npgw: '/npgw',
        bm: '/', // 子账户列表
    },
};

export const server = {
    // 例子: http://xxx.ce.com/ce-demo/login.html?accessToken=xjxhfnfiAJDHFJGJdjdenf
    // 当前url地址+端口的方法, 示例: baseURL() -> http://xxx.ce.com:8088
    baseURL: () => window.location.origin,
    // 当前不带前缀url地址, 示例: hostName() -> xxx.ce.com
    hostName: () => window.location.hostname,
    // 当前端口， 示例: hostPort() -> 8088
    hostPort: () => window.location.port,
    // 当前地址端口后的访问路径, 示例: hostPath() -> /ce-demo/login.html
    hostPath: () => window.location.pathname,
    // 获取 WebSocket 请求的 host（不带协议）
    // 本地开发(localhost)使用 dev 环境配置的测试域名，其他环境直接用当前页面 host
    wsHost: () => {
        if (window.location.hostname === 'localhost') {
            return new URL(configs.dev.host).host;
        }
        return window.location.host;
    },
    // 当前script命令的环境 // TODO WQ
    present: configs[import.meta.env.VITE_ENV_CONFIG],
    // 生产环境配置
    production: configs.prod,
    // develop环境配置
    develop: configs.dev,
    // develop mock环境配置
    developAndMock: configs.dev_mock,
    // develop release环境配置
    developAndRelease: configs.dev_build,
    // 测试环境配置
    test: configs.test,
    // 演示环境
    demo: configs.demo,
};
